const INIT_ELEMENT_ID = 'customer-data-frontend';
// Local storage IDs
const ADDRESS_VALIDATION_RULES = `${INIT_ELEMENT_ID}-address-validation-rules`;
const ADDRESS_VALIDATION_RULES_LS_KEY = ADDRESS_VALIDATION_RULES;
const REACT_APP_API_NAMESPACE = `/v2`;
const API_NAMESPACE = process.env.REACT_APP_API_NAMESPACE ?? REACT_APP_API_NAMESPACE;
const API_PATHS = {
    EDIT_EMAIL: `${API_NAMESPACE}/editemail`,
    EDIT_PASSWORD: `${API_NAMESPACE}/editpassword`,
    EDIT_INVOICE_ADDRESS: `${API_NAMESPACE}/editinvoice`,
    INITIAL_DATA: `${API_NAMESPACE}/initial-ui-data`,
    ADDRESS_VALIDATION_RULES: `${API_NAMESPACE}/address-validation-rules`,
};
const VALIDATION_MODE = 'onBlur';
const ZOOPLUS_REALM = 'zooplus';
const BITIBA_REALM = 'bitiba';
const DEFAULT_LANG = 'de';
const TEST_ID_SUFFIX = 'SameFirstAndLastNameWarning';

export { ADDRESS_VALIDATION_RULES, ADDRESS_VALIDATION_RULES_LS_KEY, API_NAMESPACE, API_PATHS, BITIBA_REALM, DEFAULT_LANG, INIT_ELEMENT_ID, TEST_ID_SUFFIX, VALIDATION_MODE, ZOOPLUS_REALM };
//# sourceMappingURL=constants.js.map
